import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mdrlAPI } from '@api/modules/mdrl';
import { optnAPI } from '@api/modules/optn';
import { suppAPI } from '@api/modules/supp';
import { imgeAPI } from '@api/modules/imge';
import { colrAPI } from '@api/modules/colr.js';
import editHeader from '@/views/component/editHeader.vue';
import inputUser from '@/views/component/inputUser.vue';
import imgPopover from '@/views/component/imgPopover.vue';
import MdrlImport from './Componet/MdrlImport.vue';
import MdrlEditCust from './Componet/MdrlEditCust.vue';
import { fillZero } from '@assets/js/StringUtils';
export default {
  name: 'mdrlEditMain',
  components: {
    editHeader: editHeader,
    inputUser: inputUser,
    imgPopover: imgPopover,
    MdrlImport: MdrlImport,
    MdrlEditCust: MdrlEditCust
  },
  data: function data() {
    return {
      mdrlForm: {
        mdrl_no: null,
        mdrl_name: null,
        mdrl_spec_en: null,
        mdrl_type: null,
        mdrl_spec: null,
        mdrl_espec: null,
        mdrl_color: '',
        mdrl_weight: null,
        mdrl_width: null,
        mdrl_unit: null,
        imge_id: null,
        imge_url: null,
        imge_urlO: null,
        mdrl_comp: null,
        mdrl_stock_limit: null,
        mdrl_price: null,
        mdrl_remark: null,
        cust_id: null,
        cust_name: null,
        supp_id: null,
        user_id: null,
        stff_id: null,
        dept_id: null,
        status: 0,
        key: 0,
        colr_class: null,
        mdrl_info_list: []
      },
      showNo: null,
      mdrlformMdrlNo: null,
      key: 0,
      isShow: true,
      uploadUrl: this.helper.modePrepend(imgeAPI.uploadImage),
      btn: {},
      stffForm: {},
      imgForm: {
        imge_id: null,
        imge_url: null,
        imge_urlO: null
      },
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }],
      mainMaterial: [{
        id: 0,
        label: 'P20精料'
      }, {
        id: 1,
        label: 'P20毛料'
      }, {
        id: 2,
        label: 'P20光料'
      }, {
        id: 3,
        label: '45#精料'
      }, {
        id: 4,
        label: '45#光料'
      }, {
        id: 5,
        label: '45#毛料'
      }, {
        id: 6,
        label: '738H精料'
      }, {
        id: 7,
        label: '718H精料'
      }],
      minorMaterial: [{
        id: 0,
        label: 'SUJ2'
      }, {
        id: 1,
        label: '20CR'
      }, {
        id: 2,
        label: '镀铜'
      }, {
        id: 3,
        label: '45#'
      }, {
        id: 4,
        label: 'STD'
      }],
      mdrlUnitList: [{
        id: 1,
        label: '件'
      }, {
        id: 2,
        label: '个'
      }, {
        id: 3,
        label: '支'
      }, {
        id: 4,
        label: '条'
      }],
      mdrlTypeGroupOpt: [],
      suppType: [],
      show: false,
      loadingFlag: true,
      compType: [],
      num_no: null,
      warningTitle: '',
      mdrlSendOrCover: null,
      optnColorList: [],
      mdrlInfoListCopy: [],
      checkedIndex: 0,
      MdrlFlag: false,
      CustTitle: '添加材料专属客户',
      imgTypeFlag: true
    };
  },
  created: function created() {
    this.initData();
  },
  watch: {},
  methods: {
    initData: function initData() {
      this.loadingFlag = true;
      this.getmdrlInfo();
      this.getMdrlType();
      this.getSuppsList();
      this.getContry();
    },
    //打开专属客户弹窗
    custImport: function custImport() {
      if (!this.isShow) {
        this.MdrlFlag = true;
      }
    },
    //关闭专属客户弹窗
    custCancel: function custCancel() {
      this.MdrlFlag = false;
    },
    //启用编辑
    openEdit: function openEdit() {
      this.isShow = false;
      this.$emit('isShow', this.isShow);
    },
    //撤销编辑
    closeEdit: function closeEdit() {
      var _this = this;

      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this.isShow = true;

        _this.$emit('isShow', _this.isShow);

        _this.show = true;

        _this.initData();

        _this.$message({
          type: 'info',
          message: '已撤销编辑!'
        });
      });
    },
    //提交表单
    submit: function submit(formName) {
      var _this2 = this;

      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$refs[formName].validate(function (valid) {
          if (valid) {
            _this2.saveInfo();
          } else {
            _this2.$message.warning('请把必填内容填写完整！');

            return false;
          }
        });
      });
    },
    // 保存
    saveInfo: function saveInfo() {
      var _this3 = this;

      var mdrlForm = JSON.parse(JSON.stringify(this.mdrlForm));
      var temp = false;
      this.mdrlInfoListCopy = this.mdrlInfoListCopy.filter(function (item) {
        return mdrlForm.mdrl_info_list.every(function (item1) {
          return item.mdrl_info_id !== item1.mdrl_info_id;
        });
      });

      for (var i = 0; i < this.mdrlInfoListCopy.length; i++) {
        this.mdrlInfoListCopy[i].destroy_flag = 1;
      }

      for (var _i in mdrlForm.mdrl_info_list) {
        if (mdrlForm.mdrl_info_list[_i].mdrl_info_checked) {
          mdrlForm.mdrl_info_list[_i].mdrl_info_checked = 1;
        } else if (!mdrlForm.mdrl_info_list[_i].mdrl_info_checked) {
          mdrlForm.mdrl_info_list[_i].mdrl_info_checked = 0;
        }
      }

      for (var _i2 in mdrlForm.mdrl_info_list) {
        if (mdrlForm.mdrl_info_list[_i2].mdrl_info_checked === 1) {
          temp = true;
        }
      }

      mdrlForm.mdrl_info_list = mdrlForm.mdrl_info_list.concat(this.mdrlInfoListCopy);
      mdrlForm.mdrl_no = mdrlForm.mdrl_no.toLocaleUpperCase() + mdrlForm.mdrl_no_suffix;

      if (temp) {
        post(mdrlAPI.editMdrl, mdrlForm).then(function (res) {
          if (res.data.code === 0) {
            _this3.$message({
              type: 'success',
              message: '保存成功'
            });

            _this3.warningTitle = '';
            _this3.isShow = true;

            _this3.$emit('isShow', _this3.isShow);

            _this3.initData();
          } else if (res.data.code === 7) {
            _this3.$message({
              type: 'error',
              message: '材料编号重复'
            });

            _this3.mdrlForm.mdrl_color = parseInt(_this3.mdrlForm.mdrl_color);
            _this3.mdrlForm.mdrl_no = _this3.mdrlForm.mdrl_no.substring(0, 2);
          } else if (res.data.code === 888) {
            var mg = res.data.msg;
            _this3.warningTitle = mg;
            var tp = 'error';

            _this3.$message({
              message: mg,
              type: tp
            });

            if (res.data.msg === '材料编号格式输入错误!') {
              _this3.mdrlForm.mdrl_no = null;
            } else {
              _this3.mdrlForm.mdrl_no = null;
              _this3.mdrlForm.mdrl_color = null;
              _this3.mdrlForm.mdrl_width = null;
            }
          }
        });
      } else {
        this.$message.warning('供应商必须有一个默认商户');
      }
    },
    // 获取单位
    getMdrlType: function getMdrlType() {
      var _this4 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10005
      }).then(function (res) {
        if (res.data.code === 0) {
          _this4.mdrlTypeGroupOpt = res.data.data;
        }
      });
    },
    // 获取供应商信息
    getSuppsList: function getSuppsList() {
      var _this5 = this;

      get(suppAPI.getSuppsV1).then(function (res) {
        if (res.data.code === 0) {
          _this5.suppType = res.data.data;
        }
      });
    },
    // 获取材料名称名字
    getContry: function getContry() {
      var _this6 = this;

      get(optnAPI.getOptnByPermId, {
        perm_id: 10013
      }).then(function (res) {
        if (res.data.code === 0) {
          _this6.mdrlNameList = res.data.data.form.optn_cntt_list;
        }
      });
    },
    // 刷新按钮
    buttonRefresh: function buttonRefresh() {
      this.initData();
    },
    // custID子传父值
    custID: function custID(val) {
      if (val) {
        this.mdrlForm.cust_id = val.join(',');
      } else {
        this.mdrlForm.cust_id = null;
      }
    },
    custName: function custName(val) {
      if (val) {
        this.mdrlForm.cust_name = val.join(',');
      } else {
        this.mdrlForm.cust_name = null;
      }
    },
    //取消
    cancel: function cancel() {
      var _this7 = this;

      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this7.resetForm('mdrlForm');

        _this7.$router.go(-1);

        _this7.$message({
          type: 'info',
          message: '已取消新增!'
        });
      });
    },
    // 新增字表数据
    addRow: function addRow() {
      var temp = {};

      if (this.mdrlForm.supp_id) {
        temp.supp_id = this.mdrlForm.supp_id;
      } else {
        temp.supp_id = null;
      }

      if (this.mdrlForm.mdrl_price) {
        temp.mdrl_price = this.mdrlForm.mdrl_price;
      } else {
        temp.mdrl_price = '0.0000';
      }

      temp.mdrl_info_checked = false;
      temp.key = this.mdrlForm.mdrl_info_list.length;
      this.mdrlForm.mdrl_info_list.push(temp);
    },
    // 删除子表数据
    deleteClick: function deleteClick(val) {
      if (this.mdrlForm.mdrl_info_list.length <= 1) {
        this.$message({
          type: 'warning',
          message: '至少保留一条'
        });
      } else {
        var flag = false;

        if (this.mdrlForm.mdrl_info_list[val.key].mdrl_info_checked) {
          flag = true;
        }

        this.mdrlForm.mdrl_info_list.splice(val.key, 1);

        for (var i in this.mdrlForm.mdrl_info_list) {
          this.mdrlForm.mdrl_info_list[i].key = i;
        }

        if (flag) {
          this.mdrlForm.mdrl_info_list[0].mdrl_info_checked = true;
          this.checkedIndex = 0;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[0].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[0].supp_id;
        } else {
          for (var _i3 in this.mdrlForm.mdrl_info_list) {
            if (this.mdrlForm.mdrl_info_list[_i3].mdrl_info_checked) {
              this.checkedIndex = _i3;
            }
          }
        }
      }
    },
    // 狭隘拉框更换
    selectChange: function selectChange(val) {
      this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val].supp_id;
    },
    // 价格变动
    inputChange: function inputChange(val) {
      this.mdrlForm.mdrl_price = this.helper.haveFour(this.mdrlForm.mdrl_info_list[val].mdrl_price);
    },
    // 更换复选框
    checkboxChange: function checkboxChange(val, val1) {
      if (val.mdrl_info_checked) {
        var flag = 0;

        for (var i in this.mdrlForm.mdrl_info_list) {
          if (this.mdrlForm.mdrl_info_list[i].mdrl_info_checked) {
            flag += 1;
          }
        }

        if (flag > 1) {
          var ind = JSON.parse(JSON.stringify(this.checkedIndex));
          this.mdrlForm.mdrl_info_list[ind].mdrl_info_checked = false;
          this.checkedIndex = val1;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[val1].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val1].supp_id;
        } else {
          this.checkedIndex = val1;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[val1].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val1].supp_id;
        }
      } else {
        var _flag = 0;

        for (var _i4 in this.mdrlForm.mdrl_info_list) {
          if (this.mdrlForm.mdrl_info_list[_i4].mdrl_info_checked) {
            _flag += 1;
          }
        }

        if (_flag === 0) {
          this.mdrlForm.mdrl_info_list[val1].mdrl_info_checked = true;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[val1].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val1].supp_id;
          this.checkedIndex = val1;
        }
      }
    },
    //表单重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 成功上传
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      if (res.code === 0) {
        if (this.imgTypeFlag) return this.$message.warning('仅支持jpg、png、jpeg格式的图片');

        if (!this.mdrlForm.imge_id) {
          this.mdrlForm.imge_id = res.data.imge_id;
        }

        var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        var urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.mdrlForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.mdrlForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      } else {
        var mg = res.msg;
        var tp = 'error';
        this.$message({
          message: mg,
          type: tp
        });
      }
    },
    // 上传头像前
    beforeAvatarUpload: function beforeAvatarUpload(res) {
      this.imgTypeFlag = false;
      var str = res.name.substring(res.name.indexOf('.') + 1, res.name.length);
      var imgTypeList = ['jpg', 'png', 'jpeg'];
      if (imgTypeList.indexOf(str) === -1) this.imgTypeFlag = true;
    },
    // 获取表单信息
    getmdrlInfo: function getmdrlInfo() {
      var _this8 = this;

      this.mdrlForm.mdrl_id = this.$route.query.form_id;
      get(mdrlAPI.getMdrlById, {
        mdrl_id: this.mdrlForm.mdrl_id
      }).then(function (res) {
        if (res.data.code === 0) {
          _this8.mdrlForm = JSON.parse(JSON.stringify(res.data.data.form));
          _this8.mdrlInfoListCopy = JSON.parse(JSON.stringify(res.data.data.form.mdrl_info_list)); //编号

          _this8.mdrlForm.mdrl_no_suffix = res.data.data.form.mdrl_no.substring(2, res.data.data.form.mdrl_no.length);
          _this8.mdrlForm.mdrl_no = res.data.data.form.mdrl_no.substring(0, 2);
          var urlEng = JSON.parse(JSON.stringify(_this8.mdrlForm.imge_url));

          if (_this8.mdrlForm.imge_id) {
            // this.mdrlForm.imge_id = this.mdrlForm.imge_id;
            _this8.dataBody.imge_id = _this8.mdrlForm.imge_id;
          } else {
            // this.mdrlForm.imge_id = 0;
            _this8.dataBody.imge_id = 0;
          }

          var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
          _this8.mdrlForm.imge_url = _this8.helper.picUrl(urlEng, 's', updateTime);
          _this8.mdrlForm.imge_urlO = _this8.helper.picUrl(urlEng, 'l', updateTime);

          if (_this8.show) {
            _this8.mdrlForm.imge_id = _this8.imgForm.imge_id;
            _this8.mdrlForm.imge_url = _this8.imgForm.imge_url;
            _this8.mdrlForm.imge_urlO = _this8.imgForm.imge_urlO;
            _this8.show = false;
          }

          _this8.imgForm.imge_url = JSON.parse(JSON.stringify(_this8.mdrlForm.imge_url));
          _this8.imgForm.imge_id = JSON.parse(JSON.stringify(_this8.mdrlForm.imge_id));
          _this8.imgForm.imge_urlO = JSON.parse(JSON.stringify(_this8.mdrlForm.imge_urlO));
          _this8.mdrlForm.mdrl_price = _this8.helper.haveFour(_this8.mdrlForm.mdrl_price);
          _this8.mdrlForm.mdrl_weight = _this8.helper.reservedDigits(_this8.mdrlForm.mdrl_weight);

          for (var i in _this8.mdrlForm.mdrl_info_list) {
            _this8.mdrlForm.mdrl_info_list[i].mdrl_price = _this8.helper.haveFour(_this8.mdrlForm.mdrl_info_list[i].mdrl_price);
          }

          _this8.stffForm.stff_name = _this8.mdrlForm.stff_name;
          _this8.stffForm.dept_name = _this8.mdrlForm.dept_name;
          _this8.stffForm.dept_team_name = _this8.mdrlForm.dept_team_name;
          _this8.stffForm.user_id = _this8.mdrlForm.user_id;
          _this8.stffForm.dept_id = _this8.mdrlForm.dept_id;
          _this8.stffForm.stff_id = _this8.mdrlForm.stff_id;
          _this8.btn = res.data.data.btn;

          for (var _i5 in _this8.mdrlForm.mdrl_info_list) {
            _this8.mdrlForm.mdrl_info_list[_i5].key = _i5;

            if (_this8.mdrlForm.mdrl_info_list[_i5].mdrl_info_checked === 1) {
              _this8.mdrlForm.mdrl_info_list[_i5].mdrl_info_checked = true;
              _this8.checkedIndex = Number(_i5);
            } else if (!_this8.mdrlForm.mdrl_info_list[_i5].mdrl_info_checked === 0) {
              _this8.mdrlForm.mdrl_info_list[_i5].mdrl_info_checked = false;
            }
          } // 为辅料 和 包材时的编号


          if (_this8.mdrlForm.mdrl_type !== 0) {
            _this8.showNo = res.data.data.form.mdrl_no.substring(2) + '';
          }

          setTimeout(function () {
            _this8.loadingFlag = false;
          }, 500);
        }
      });
    },
    mdrlColorInput: function mdrlColorInput() {
      this.mdrlForm.mdrl_color = this.helper.keepTNum(this.mdrlForm.mdrl_color);
      this.mdrlForm.mdrl_color = this.mdrlForm.mdrl_color.substring(0, 4);
    },
    typeChange: function typeChange() {
      if (this.mdrlForm.mdrl_type !== 0) {
        this.mdrlForm.mdrl_color = '';
        this.mdrlForm.colr_class = '';
      } else {
        this.mdrlForm.colr_class = null;
      }
    },
    //同步颜色 大类
    clickSyncColor: function clickSyncColor() {
      var _this9 = this;

      get(colrAPI.getColrClassByPantone, {
        colr_pantone: this.mdrlForm.mdrl_color + 'C'
      }).then(function (res) {
        if (res.data.code === 0) {
          _this9.mdrlForm.colr_class = res.data.data.form.colr_class;

          _this9.$message.success('同步' + res.data.msg);

          return;
        } else if (res.data.code === 2) {
          _this9.$message.warning('未匹配到该颜色大类');

          return;
        }

        _this9.$message.warning(res.data.msg);
      });
    }
  }
};